import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import FileUploader from "../FileUploader";

const ResponsiveModal = styled(Modal)`
  .modal-body {
    padding: 40px !important;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .modal-content {
    border-radius: 10px !important;
    max-height: 90vh;
  }

  .modal-dialog {
    max-width: 700px !important;
  }

  @media screen and (max-width: 767px) {
    .modal-content {
      width: 90% !important;
      margin: 0 auto !important;
    }
  }
`;

const ButtonBack = styled.img`
  filter: brightness(0) saturate(100%) invert(58%) sepia(59%) saturate(452%)
    hue-rotate(103deg) brightness(92%) contrast(83%);
  cursor: pointer;
  margin: 0 5px 5px 0;
`;

export function BlackListModal({
  isCreateBlackListModalOpen,
  setIsCreateBlackListModalOpen,
  getBlackList,
  setNeedRefetch,
  needRefetch
}) {
  useEffect(() => {
    if (needRefetch) {
      getBlackList();
      setNeedRefetch(false);
    }
  }, [needRefetch]);

  return (
    <ResponsiveModal
      show={isCreateBlackListModalOpen}
      onHide={() => setIsCreateBlackListModalOpen(false)}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <ButtonBack
          onClick={() => setIsCreateBlackListModalOpen(false)}
          src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")}
        />
        <FileUploader
          uploadUrl={"black_list_document"}
          setNeedRefetch={setNeedRefetch}
          setIsCreateBlackListModalOpen={setIsCreateBlackListModalOpen}
        ></FileUploader>
      </Modal.Body>
    </ResponsiveModal>
  );
}
